import { useSettings } from "@/context/SettingsContext";
import { Seo } from "@/components/site/Seo";
import { Mountain, Sparkles, HeartHandshake, ShieldCheck } from "lucide-react";

export default function About() {
  const { settings } = useSettings();
  return (
    <div className="pt-16">
      <Seo title="About Us" description="Who we are — the story, values and team behind our curated treks, trips and yatras across India." />
      <div className="relative h-72 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1665849865197-6b4f0d1206e1?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000" alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-black/50" />
        <div className="relative z-10 mx-auto max-w-7xl px-6 h-full flex flex-col justify-end pb-10 text-white">
          <p className="uppercase tracking-[0.25em] text-gold text-sm">Our Story</p>
          <h1 className="font-heading text-5xl sm:text-6xl font-semibold">About {settings.brand_name || "Safarshala"}</h1>
        </div>
      </div>
      <div className="mx-auto max-w-3xl px-6 py-16">
        <p className="text-xl leading-relaxed text-foreground/80 font-heading">{settings.about}</p>
        <div className="mt-12 grid sm:grid-cols-3 gap-6">
          {[{ i: Sparkles, t: "Curated" }, { i: HeartHandshake, t: "Premium Hospitality" }, { i: ShieldCheck, t: "Trusted Support" }].map((x) => (
            <div key={x.t} className="rounded-2xl border p-6 text-center">
              <x.i className="h-8 w-8 text-primary mx-auto mb-3" />
              <p className="font-heading text-xl">{x.t}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
